import {parseDoc} from "./parseDoc";
import { QuerySnapshot } from "firebase/firestore";

export function getDocsFromSnapshot<T>(
  snapshot: QuerySnapshot
): T[] {
  return snapshot.docs.map(parseDoc<T>);
}
